import videojs from 'video.js';

import './seekbar-segment-progress-bar.css'

const _startTime = new WeakMap();
const _endTime = new WeakMap();

const DEFAULT_PROGRESS_WIDTH = 0;

export default class SeekBarSegmentProgressBar extends videojs.getComponent('Component') {
    /**
     *
     * @param {videojs.Player} player
     * @param {Object} options
     * @param {number} options.startTime
     * @param {number} options.endTime
     */
    constructor(player, options) {
        super(player, options);

        player.ready(() => {
            const { startTime, endTime } = options;

            this.startTime = startTime;
            this.endTime = endTime;
            this.segmentWidth = this.el().parentElement.getBoundingClientRect().width;

            const resizeOb = new ResizeObserver(entries => {
                for (const entry of entries) {
                    this.updateWidth();
                }
            })

            resizeOb.observe(this.player().getChild('ControlBar').getChild('ProgressControl').getChild('SeekBar').getChild('PlayProgressBar').el());
        });
    }

    set startTime(startTime) {
        _startTime.set(this, startTime);
    }

    get startTime() {
        return _startTime.get(this);
    }

    set endTime(endTime) {
        _endTime.set(this, endTime);
    }

    get endTime() {
        return _endTime.get(this);
    }

    set width(width) {
        this.el().style.width = width;
    }

    get width() {
        return this.el().style.width;
    }

    updateWidth() {
        const startTime = this.startTime;
        const endTime = this.endTime;
        const segmentWidth = this.el().parentElement.getBoundingClientRect().width;
        const playProgressBarPosition = this.player().getChild('ControlBar').getChild('ProgressControl').getChild('SeekBar').getChild('PlayProgressBar').el().getBoundingClientRect().width;
        const seekBarWidth = this.player().getChild('ControlBar').getChild('ProgressControl').getChild('SeekBar').el().getBoundingClientRect().width;

        const startPosition = (startTime / this.player().duration()) * seekBarWidth;
        const endPosition = (endTime / this.player().duration()) * seekBarWidth;

        if (playProgressBarPosition > endPosition) {
            this.width = '100%';
        } else if (playProgressBarPosition < startPosition) {
            this.width = '0%';
        } else {
            this.width = `${((playProgressBarPosition - startPosition) / segmentWidth) * 100}%`;
        }

    }

    createEl(tag, props = {}, attributes = {}) {
        tag = 'div';
        props = Object.assign({
            className: 'mediasite-player__seekbar-segment-progress-bar'
        });
        attributes = Object.assign({
            style: `width: ${DEFAULT_PROGRESS_WIDTH}%`
        });
        return super.createEl.call(this, tag, props, attributes);
    }

}